<div id="topbar" class="d-flex flex-row h-100 align-items-center align-content-center">
    <div id="selected-section" class="d-flex h-100 justify-content-between align-items-center align-content-center"
        (click)="showSelectSectionModal()" (touchend)="showSelectSectionModal()">
        <span>{{selectedSection?.sectionName}}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="#57938e" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
    </div>
    <div id="topbar-inner" class="">

        <!-- toggle sidepanel -->
        <a class="btn btn-sm px-2" (click)="toggleCollapseSidePanel()">
            @if (sidePanelCollapsed) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
                </svg>
            } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
                </svg>
            }
        </a>

        @if (!editMode) {
            <div id="reservations-info" class="d-flex flex-row justify-content-center w-100 align-content-center align-items-center">
                <!-- section name -->
                <span class="section-name">{{selectedSection?.sectionName}}</span>

                <!-- summary -->
                    <ng-container *ngIf="(reservationsFilteredByShiftAndSection | reservationsInfo) as blocking">
                        <span class="d-flex flex-wrap counts res-counts text-sm">
                            <span>P <span
                                class="text-link text-normal">{{blocking.pendingCovers}}</span>/{{blocking.totalCovers}}&nbsp;&nbsp;
                            </span>
                            <span>
                                R
                                <span class="text-link text-normal">{{blocking.pendingRes}}</span>/{{blocking.totalRes}}
                            </span>
                        </span>
                    </ng-container>
            </div>
        } @else {
            <div class="tables-mode-container d-flex justify-content-center flex-grow-1">
                <button type="button" [class]="'btn btn-sm ' + (tablesMode == 'Tables' ? 'btn-main' : 'btn-sec')" (click)="setTablesMode('Tables')" 
                    [class.disabled]="editMode && (editingTable != null || this.addJoinedTablesMode || assignCategoriesToTablesMode || isOnExcludeFromOnlineChannelsMode)">
                    {{ 'tablesPlan.editMode.tables' | translate }}
                </button>
                <button type="button" [class]="'btn btn-sm ' + (tablesMode == 'JoinedTables' ? 'btn-main' : 'btn-sec')" (click)="setTablesMode('JoinedTables')" 
                    [class.disabled]="editMode && (editingTable != null || this.addJoinedTablesMode || assignCategoriesToTablesMode || isOnExcludeFromOnlineChannelsMode)">
                    {{ 'tablesPlan.editMode.joinTables' | translate }}
                </button>
            </div>
        }
        
    </div>
</div>

<app-modal-dialog #selectSectionModal title="{{'tablesPlan.sectionsModal.title' | translate}}"
    modalId="selectSection-modal" [isValid]="true" [hasCancel]="true" [hasOk]="false" [hasClose]="false">
    <div class="sections">
        @for (section of workingDateSections; track section.sectionId) {
            <div>
                <div class="btn btn-sec px-0 w-100" [class.active]="section.sectionId === selectedSection?.sectionId"
                    (click)="setSection(section)" (touchend)="setSection(section)">{{section.sectionName}}</div>
                
                    @if (editMode) {
                        <a class="btn btn-sm btn-main px-2" (click)="editSection(section)">
                            <app-icon icon="Edit"></app-icon>
                        </a>
    
                        <a class="btn btn-sm btn-danger px-2" (click)="showDeleteSectionConfirmation(section)">
                            <app-icon icon="Delete"></app-icon>
                        </a>
                    }
                    
            </div>
        }
    </div>

    @if (editMode) {
        <a class="btn btn-main w-full px-2 mt-5" (click)="addSection()">
            {{ 'tablesPlan.sectionsModal.addSection' | translate }}
        </a>
    }
    
</app-modal-dialog>

<app-modal-dialog #addEditSectionModal title="{{'tablesPlan.addEditsectionsModal.title' | translate}}"
    modalId="addEditSection-modal" [isValid]="true" [hasCancel]="false" [hasOk]="false" [hasClose]="false">
    
    <div class="d-flex">
        <div class="d-flex flex-column">
            <span>{{'tablesPlan.addEditsectionsModal.order' | translate}}</span>
            <input [ngModel]="editingSection?.sectionOrder"
                (ngModelChange)="setSectionOrder($event)" required type="number"
                class="ihost-control w-20 mb-2" />
        </div>
        <div class="d-flex flex-column flex-grow-1">
            <span>{{'tablesPlan.addEditsectionsModal.sectionName' | translate}}</span>
            <input [ngModel]="editingSection?.sectionName"
                (ngModelChange)="setSectionName($event)" required type="text"
                class="ihost-control w-full mb-2" />
        </div>
    </div>

    <!-- validation message -->
    <p class="text-danger text-sm">{{validationMessage}}</p>

    <div class="d-flex mt-4">
        <button type="button" class="btn btn-faded flex-grow-1" (click)="cancelEditSection()">
            {{ 'common.buttons.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-main flex-grow-1" (click)="applySectionChanges()">
            {{ 'tablesPlan.addEditsectionsModal.setBtn' | translate}}
        </button>
    </div>

</app-modal-dialog>

<app-modal-dialog #confirmDeleteSectionModal title="{{'tablesPlan.confirmEditSectionModal.title' | translate}}"
    modalId="confirmDeleteSection-modal" [isValid]="true" [hasCancel]="true" [hasClose]="false"
    okText="{{ 'common.yes' | translate }}" cancelText="{{ 'common.no' | translate }}"
    [customClose]="true" (onClose)="cancelDeleteSection($event)"
    [static]="true" footerClass="justify-content-end">
    <div class="form-col">
        <p [innerHTML]="'tablesPlan.confirmEditSectionModal.message' | translate : { section: editingSection?.sectionName }"></p>
    </div>
</app-modal-dialog>
